import getShareledgers from "./actions/get_shareledgers";
import getShareledger from "./actions/get_shareledger";
import fetchShareledger from "./actions/fetch_shareledger";

export default {
    getShareledgers,
    getShareledger,
    fetchShareledger
};
